import { AliasToken } from 'antd/es/theme/internal';
import { responsiveStyle } from '../../util/helpers';
import { windowBreakpoints } from '../../hooks/useDeviceSize';

export const responsiveModalDrawerStyle = (breakpoints: windowBreakpoints, token?: AliasToken) =>
  responsiveStyle(breakpoints, {
    header: {
      fontSize: '16px',
    },
    icon: { cursor: 'pointer', pointerEvents: 'all' },
    headerContainer: {
      width: '100%',
      '@desktop': {
        borderBottom: '1px solid #D9D9D9',
        marginBottom: '24px',
        paddingBottom: '24px',
      },
    },
    backButton: {
      fontSize: '18px',
      color: 'gray',
      fontWeight: 'medium',
      fontFamily: 'Arial',
      opacity: 0.6,
      cursor: 'pointer',
      marginRight: '10px',
      lineHeight: '1.5',
    },
    closeButton: {
      fontSize: '14px',
      color: 'gray',
      fontWeight: 'medium',
      fontFamily: 'Arial',
      opacity: 0.6,
      cursor: 'pointer',
      marginLeft: '10px',
      lineHeight: '1.5',
    },
    footer: {},
  });
